import { forwardRef } from 'react';

import { IconButton, IconButtonProps, makeStyles } from '@material-ui/core';

import classNames from 'classnames';

// Preserves the look of BUI's IconButton variant="secondary", which MUI v4
// cannot express through theme overrides (IconButton has no variant concept).
// TODO: Remove in the Encore migration — icon buttons should not diverge from
// the theme's default styling in the final state.
const useStyles = makeStyles({
  root: {
    backgroundColor: 'var(--background-tinted-base)',
    borderRadius: 'var(--encore-corner-radius-base)',
    width: 32,
    height: 32,
    // Doubled class beats MUI's `.MuiIconButton-root.Mui-disabled`
    // which otherwise resets the background to transparent.
    '&&:disabled': {
      backgroundColor: 'var(--background-tinted-base)',
    },
  },
});

export type SecondaryIconButtonMuiProps = IconButtonProps;

/** @deprecated Legacy MUI copy - migrate consumers to Encore's `ButtonIcon variant="secondary"` and delete. */
export const SecondaryIconButtonMui = forwardRef<
  HTMLButtonElement,
  SecondaryIconButtonMuiProps
>(({ className, size = 'small', ...props }, ref) => {
  const classes = useStyles();

  return (
    <IconButton
      ref={ref}
      size={size}
      className={classNames(classes.root, className)}
      data-track-source-anchor="ed0b67a9c9;secondary-icon-button-mui-icon-button;low" {...props}
    />
  );
});

SecondaryIconButtonMui.displayName = 'SecondaryIconButtonMui';
